<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="m-3">
            <h3>Add New Law</h3>
            <AddElement category_id="3"></AddElement>
        </div>
    </div>
</template>
  
<script>
import AddElement from "@/components/ElementComponents/AddElement.vue";

export default {
    name: "AddNewLaw",
    components: {
        AddElement,
    },
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Laws',
                    to: '/laws/all'
                }, {
                    text: 'Add Law',
                    href: '#'
                }
            ],
        };
    },
};
</script>